import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { OrganisationPermissionType } from '@assetaccountant/api/models/organisation-permission-type';
import { AppNavigationService } from '@assetaccountant/core/services/app-navigation.service';
import { SubscriptionService } from '@assetaccountant/core/services/subscription.service';
import { TypedNgbModal, setupModal } from '@assetaccountant/core/utils/typed-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';

import { AssetAccountantSubscription } from '@assetaccountant/api/models/asset-accountant-subscription';
import { OrganisationDto } from '@assetaccountant/api/models/organisation.dto';
import { ViewPricingModalComponent } from '../navigation/view-pricing-modal/view-pricing-modal.component';

@Component({
  selector: 'app-subscription-limit',
  templateUrl: './subscription-limit.component.html',
  styleUrls: ['./subscription-limit.component.scss'],
  standalone: false,
})
export class SubscriptionLimitComponent implements OnInit, OnChanges, OnDestroy {
  @Input() addingAssetsCount = 1;
  @Input() addingRegistersCount = 0;

  @Output() packageUpdated = new EventEmitter();

  activeOrganisation: OrganisationDto;
  isAssetLimitReached = false;
  isRegisterLimitReached = false;
  singleAsset = true;
  subscription: AssetAccountantSubscription;
  subscriptions: Subscription[] = [];
  OrganisationPermissionType = OrganisationPermissionType;

  get orgSettingsLink() {
    return ['/organisations', this.activeOrganisation.organisationId, 'settings'];
  }

  constructor(
    private subscriptionService: SubscriptionService,
    private appNavigationService: AppNavigationService,
    @Inject(NgbModal) public ngbModal: TypedNgbModal,
    private router: Router,
  ) {}

  ngOnInit() {
    this.activeOrganisation = this.appNavigationService.getActiveOrganisation();
    this.subscriptions.push(
      this.subscriptionService
        .getSubscription(this.activeOrganisation.organisationId)
        .subscribe(r => {
          this.handleSubscriptionResponse(r);
        }),
    );

    this.subscriptions.push(
      this.subscriptionService.subscription.pipe(skip(1)).subscribe(r => {
        this.handleSubscriptionResponse(r);
      }),
    );
  }

  ngOnChanges() {
    if (this.subscription) {
      this.handleSubscriptionResponse(this.subscription);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  upgradeSubscription() {
    setupModal(
      this.ngbModal.open(ViewPricingModalComponent, { size: 'xl' }),
      modal => {
        modal.destinationRouteCommand = this.router.url;
      },
      modal => modal.packageUpdated.subscribe(() => this.packageUpdated.emit()),
    );
  }

  private handleSubscriptionResponse(subscription: AssetAccountantSubscription) {
    this.subscription = subscription;

    // Manually check asset limit is reached, if more than one asset is being addded
    this.isAssetLimitReached =
      this.addingAssetsCount > 1 && subscription.packageMaxAssets
        ? subscription.totalAssets + this.addingAssetsCount > subscription.packageMaxAssets
        : subscription.isAssetLimitReached;

    this.isRegisterLimitReached = subscription.isRegisterLimitReached;
    this.singleAsset = subscription.totalAssets >= (subscription.packageMaxAssets || 0);
  }
}
